module.exports = __webpack_public_path__ + "static/Mobile_landing_splash-31d938884cb556b2a45d97c28d1c2011.svg";